let toHTML = (htmlString) => {
  var div = document.createElement("div");
  div.innerHTML = htmlString.trim();
  return div.firstChild;
};
let asideCartEvents = [
  "icartUpdateCartEvent",
  "icartSideCartOpenEvent",
  "icartAddToCartEvent",
];
asideCartEvents.forEach((_event) => {
  window.addEventListener(_event, () => {
    window.IcartChkSelector = [];
    let cart_buttons_wrapper = document.querySelector(".icartCheckoutBtnGroup");
    let checkout_button_template = `
          <button type="button" evolvehub-checkout-url class="icart-button-radius icart-btn-large icart-align-bottom" style="color: rgb(255, 255, 255);background-color: rgb(0, 0, 0);border-color: rgb(0, 0, 0);border-radius: 0px;padding: 1em;height: auto;padding: 2em 1em;">Comprar Agora</button>
     `;

    document.querySelectorAll('[name="icartCheckout"]').forEach((button) => {
      button.style.display = "none";
    });

    if (
      cart_buttons_wrapper &&
      !cart_buttons_wrapper.querySelector("[evolvehub-checkout-url]")
    ) {
      cart_buttons_wrapper.appendChild(toHTML(checkout_button_template));
      EvolveCore.Checkout.setEvents();
    }
  });
});

let updateSideCart = setInterval(() => {
  window.IcartChkSelector = [];
  let cart_buttons_wrapper = document.querySelector(".icartCheckoutBtnGroup");
  let checkout_button_template = `
        <button type="button" evolvehub-checkout-url class="icart-button-radius icart-btn-large icart-align-bottom" style="color: rgb(255, 255, 255);background-color: rgb(0, 0, 0);border-color: rgb(0, 0, 0);border-radius: 0px;padding: 1em;height: auto;">Comprar Agora</button>
    `;

  document.querySelectorAll('[name="icartCheckout"]').forEach((button) => {
    button.style.display = "none";
  });
  if (cart_buttons_wrapper) {
    if (
      ![...cart_buttons_wrapper.classList].includes(
        "evolvehub-checkout--ready"
      ) &&
      !cart_buttons_wrapper.querySelector("[evolvehub-checkout-url]")
    ) {
      cart_buttons_wrapper.appendChild(toHTML(checkout_button_template));
      cart_buttons_wrapper.classList.add("evolvehub-checkout--ready");
      EvolveCore.Checkout.setEvents();
    }
  }
}, 250);

updateSideCart;

document
  .querySelectorAll("[evolvehub-quick-checkout-url]")
  .forEach((button) => {
    button.addEventListener("click", async (e) => {
      e.preventDefault();
      e.stopPropagation();

      EvolveCore.Cart.clear = async () => {
        try {
          let response = await axios.get("/cart/clear.js", {});
          return response.data;
        } catch (e) {
          console.error(e);
          console.info("Error clearCart");
          throw new Error(e);
        }
      };
      await EvolveCore.Cart.clear();
      await EvolveCore.Cart.addProducts([
        {
          variant: {
            key: document.querySelector('[name="id"]')
              ? +document.querySelector('[name="id"]').value
              : 1,
          },
          quantity: document.querySelector('[name="quantity"]')
            ? +document.querySelector('[name="quantity"]').value
            : 1,
          properties: {},
        },
      ]);
      await EvolveCore.Checkout.Redirect();
      return true;
    });
  });
